import React from 'react';

import {
  GoogleLogin,
  GoogleLoginProps,
  GoogleLoginResponse,
} from 'react-google-login';
import styled from 'styled-components';

import {
  Box,
  BoxProps,
} from '@waglabs/box-next';

import {
  ENV_GOOGLE_CLIENT_ID,
  DataTestIds,
} from '../../constants';
import LoadingBoneModal from '../../containers/WagSignUp/components/LoadingBoneOverlay';
import { useGoogleLogin } from '../../hooks/api/useGoogleLogin';
import { SignInWithGoogleIcon } from '../../icons';

/*
  Due to this issue with the react-google-login button
  important styles must be added to the button to override the
  underlying component. An alternate option would be to for the repo
  and apply the changes outlined in the issue.
  https://github.com/anthonyjgrove/react-google-login/issues/484
*/
const StyledGoogleLogin = styled(GoogleLogin)<{ error: boolean }>`
  box-shadow: unset !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  height: 40px !important;
  padding:0px !important;
  outline:none !important;
  display: flex !important;
  align-self: flex-end !important;
`;

export type SignInWithGoogleButtonProps = BoxProps & Partial<Omit<GoogleLoginProps, 'onSuccess'>> & {
  onSuccess?: (response: GoogleLoginResponse) => void;
  children?: string;
  setIsLoadingGoogleSignIn: (loadingState: boolean) => void;
};

export const SignInWithGoogleButton = ({
  children = 'Sign in with Google',
  onSuccess,
  setIsLoadingGoogleSignIn,
  ...rest
}: SignInWithGoogleButtonProps) => {
  const {
    isLoading: isGoogleLoginLoading,
  } = useGoogleLogin();

  return (
    <>
      {isGoogleLoginLoading && (
        <LoadingBoneModal />
      )}
      <Box
        as={StyledGoogleLogin}
        disabled={isGoogleLoginLoading}
        onSuccess={onSuccess}
        clientId={ENV_GOOGLE_CLIENT_ID}
        buttonText={children}
        data-testid="Google-Login-Button"
        icon={false}
        justifyContent="center"
        onFailure={(error) => {
          console.error('Google login error: ', error);
          setIsLoadingGoogleSignIn(false);
        }}
        onAutoLoadFinished={() => {
          setIsLoadingGoogleSignIn(false);
        }}
        {...rest}
      >
        <SignInWithGoogleIcon />
      </Box>
    </>
  );
};
